import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import type { LocaleUtils } from 'react-day-picker/types/utils';
import { PaletteUtils } from '@shared/utils';
import { BaseSelect } from '../select';

interface DatePickerCaptionProps {
  date?: Date;
  localeUtils?: LocaleUtils;
  locale?: string;
  from?: Date;
  to?: Date;
  onChange: (date: Date) => void;
}

export const DatePickerCaption = (props: DatePickerCaptionProps) => {
  const { t } = useTranslation();

  const months = props.localeUtils!.getMonths('ru');
  const currentDate: Date = props.date || new Date();
  const currentYear = currentDate.getFullYear();
  const month = months[currentDate.getMonth()];

  const handleChange = (selectedValue: string | number) => {
    const parts = selectedValue.toString().split(' ');
    const monthIndex = months.indexOf(parts[0]);
    const year = parseInt(parts[1], 10);
    const newDate: Date = new Date(year, monthIndex);

    props.onChange(newDate);
  };

  const value = useMemo(() => `${month} ${currentYear}`, [t, month, currentYear]);
  const values = useMemo(
    () => months.map((item) => ({ label: `${t(`months.${item.toLowerCase()}`)} ${currentYear}`, value: `${item} ${currentYear}` })),
    [t, months, currentYear],
  );
  return (
    <div
      className={clsx(
        'table-caption font-sans text-sm -tracking-[0.2px] left-0 pb-[19px] absolute uppercase -top-2 w-full',
        PaletteUtils.isBordierPalette ? 'text-[#4d3b2c]' : 'text-[#4c4c52]',
      )}
      onClick={(e) => e.stopPropagation()}
    >
      <BaseSelect
        className='max-w-[176px] mx-auto'
        selectClassName='!px-2 justify-between gap-3 !w-full'
        values={values}
        value={value}
        onChange={(val) => handleChange(val)}
      />
    </div>
  );
};
